import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.api.title'),
      "subtitle": _vm.$i18n_t('Common.api.subtitle')
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": "niotix REST API",
      "buttons": _vm.buttons01
    },
    on: {
      "open": function ($event) {
        return _vm.open('n20a');
      }
    }
  }, [_c('markdown-it-vue-light', {
    staticClass: "mt-6",
    attrs: {
      "content": _vm.n20aText || _vm.$i18n_t('Common.notAvailable')
    }
  }), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.api.reachIt')) + " \n        "), _c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v(_vm._s(_vm.xapiProtocol) + "://" + _vm._s(_vm.xapiHost) + "/xapi/v1/...")]), _c('p'), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.api.swaggerJsonLink')) + " \n        "), _c('a', {
    attrs: {
      "href": `${_vm.xapiProtocol}://${_vm.xapiHost}/xapi/jsonserve`,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v(_vm._s(_vm.xapiProtocol) + "://" + _vm._s(_vm.xapiHost) + "/xapi/jsonserve")])])], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": "niota 1.x IoT Hub REST API",
      "buttons": _vm.buttons01
    },
    on: {
      "open": function ($event) {
        return _vm.open('n10a');
      }
    }
  }, [_c('markdown-it-vue-light', {
    staticClass: "mt-6",
    attrs: {
      "content": _vm.$i18n_t('Common.api.n10a') || _vm.$i18n_t('Common.notAvailable')
    }
  }), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.api.reachIt')) + " \n        "), _c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v(_vm._s(_vm.originUrl) + "/api/...")])], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": "firefly LNS API",
      "buttons": _vm.buttons01
    },
    on: {
      "open": function ($event) {
        return _vm.open('firefly');
      }
    }
  }, [_c('markdown-it-vue-light', {
    staticClass: "mt-6",
    attrs: {
      "content": _vm.$i18n_t('Common.api.firefly') || _vm.$i18n_t('Common.notAvailable')
    }
  }), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.api.reachIt')) + " \n        "), _c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v("https://api." + _vm._s(_vm.fireflyHost) + "/api/v1...")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };